{
    "F3Ak6p5r3qVscjqFuQBZm": {
        "key": "F3Ak6p5r3qVscjqFuQBZm",
        "position": {
            "x": 5,
            "y": 1,
            "z": 1
        },
        "tag": "spawngood"
    },
    "a9UDiTtndZfvar4TmWRyn": {
        "key": "a9UDiTtndZfvar4TmWRyn",
        "position": {
            "x": 5,
            "y": 0,
            "z": 1
        },
        "tag": "spawngood"
    },
    "-KkFJzUgZHKJtdIoYk42O": {
        "position": {
            "x": 3,
            "y": 2,
            "z": 1
        },
        "direction": {
            "x": 0,
            "y": 1
        },
        "key": "-KkFJzUgZHKJtdIoYk42O",
        "tag": "spawnbadnorth"
    },
    "-KkFJzUgZHKJtdIoYk42O2": {
        "position": {
            "x": 3,
            "y": 6,
            "z": 1
        },
        "direction": {
            "x": 1,
            "y": 0
        },
        "key": "-KkFJzUgZHKJtdIoYk42O2",
        "tag": "spawnbadsouth"
    },
    "DIUktopkvgzJUqXrYx3Su": {
        "position": {
            "x": 3,
            "y": 1,
            "z": 1
        },
        "key": "DIUktopkvgzJUqXrYx3Su",
        "tag": "victory"
    }
}